// extracted by mini-css-extract-plugin
export default {"orderItemContainer":"orderHistory_orderItemContainer__d54Lp","loadMoreBtn":"orderHistory_loadMoreBtn__ngmpR"};